import { Fragment, PropsWithChildren, useState } from "react";

import { Button, ButtonProps } from "@material-ui/core";

import { Apartment } from "../../../graphql/models";
import { DialogWithActions } from "../dialog_with_actions";
import { AddUserToApartmentWizard } from "../add_user_to_apartment_wizard";

export interface AddUserToApartmentButtonProps
  extends Omit<ButtonProps, "onClick"> {
  apartment: Apartment;
  onAdd?: () => void;
}

export function AddUserToApartmentButtonWithDialog(
  props: AddUserToApartmentButtonProps & PropsWithChildren<{}>
) {
  const { apartment, children, onAdd, ...buttonProps } = props;

  const [open, setOpen] = useState(false);

  const triggerOnAdd = () => {
    if (onAdd) {
      onAdd();
    }
    setOpen(false);
  };

  return (
    <Fragment>
      <DialogWithActions
        open={open}
        setOpen={setOpen}
        fullScreen={false}
        title={"Aggiungi nuovo ospite"}
      >
        <AddUserToApartmentWizard apartment={apartment} onAdd={triggerOnAdd} />
      </DialogWithActions>
      <Button onClick={() => setOpen(true)} {...buttonProps}>
        {children ?? "Aggiungi nuovo ospite"}
      </Button>
    </Fragment>
  );
}
